import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col, Spinner, Alert } from "react-bootstrap";
import { getCompanyByCompanyID } from '../../actions/companyAction';
import CompanyView from './View';

class MyCompany extends Component {
  state = {
    loading: true,
    error: null,
    companyId: null
  };

  componentDidMount() {
    this.loadMyCompany();
  }

  loadMyCompany = async () => {
    try {
      const { user } = this.props;
      
      if (!user || !user.company_id) {
        this.setState({ 
          loading: false, 
          error: 'Bạn chưa được gán vào công ty nào.' 
        });
        return;
      }

      this.setState({ loading: true, error: null });
      
      // Load company by company_id from user
      const response = await this.props.getCompanyByCompanyID(user.company_id);
      
      if (response && response.data && response.data._id) {
        this.setState({ 
          loading: false, 
          companyId: response.data._id 
        });
      } else {
        this.setState({ 
          loading: false, 
          error: `Không tìm thấy thông tin công ty với ID: ${user.company_id}` 
        });
      }
    } catch (error) {
      console.error('Error loading my company:', error);
      this.setState({ 
        loading: false, 
        error: 'Lỗi khi tải thông tin công ty: ' + (error.response?.data?.message || error.message)
      });
    }
  };

  render() {
    const { loading, error, companyId } = this.state;
    const { user } = this.props;

    if (loading) {
      return (
        <Container fluid className="text-center py-5">
          <Spinner animation="border" variant="primary" />
          <div className="mt-2">Đang tải thông tin công ty...</div>
        </Container>
      );
    }

    if (error) {
      return (
        <Container fluid>
          <Row className="justify-content-center">
            <Col md={8}>
              <Alert variant="warning" className="text-center">
                <h5>Không thể tải thông tin công ty</h5>
                <p>{error}</p>
                {user && user.company_id && (
                  <small className="text-muted">
                    Company ID trong hồ sơ: {user.company_id}
                  </small>
                )}
              </Alert>
            </Col>
          </Row>
        </Container>
      );
    }

    if (!companyId) {
      return (
        <Container fluid>
          <Row className="justify-content-center">
            <Col md={8}>
              <Alert variant="info" className="text-center">
                <h5>Chưa có thông tin công ty</h5>
                <p>Vui lòng liên hệ quản trị viên để được gán vào công ty.</p>
              </Alert>
            </Col>
          </Row>
        </Container>
      );
    }

    // Render CompanyView with the found company ID
    return (
      <CompanyView
        match={{ 
          params: { id: companyId } 
        }}
        history={this.props.history}
        isMyCompany={true}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.authenReducer.user,
  loading: state.companyReducer.loading,
  error: state.companyReducer.error
});

export default connect(mapStateToProps, {
  getCompanyByCompanyID
})(MyCompany);
